import { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Link } from "react-router-dom";

import acne from "../../Images/acne.webp";
import haircare from "../../Images/hair care.webp";
import dullSkin from "../../Images/Dull Skin.webp";
import tan from "../../Images/Tanning (1).webp";
import oily from "../../Images/Oily skin.webp";
import dry from "../../Images/Dry skin.webp";
import aging from "../../Images/aging.webp";
import spot from "../../Images/spot.jpg";

import "./ShopByConcern.css";

const concerns = [
  { slug: "acne", label: "Acne", img: "https://i.ibb.co.com/rfcCTtc8/ebay-shop-by-con-2.jpg", alt: "Acne skincare products" },
  { slug: "haircare", label: "Haircare", img: "https://i.ibb.co.com/S9yCWb4/ebay-shop-by-con-3.jpg", alt: "Hair care solutions" },
  { slug: "dullskin", label: "Dull Skin", img: "https://i.ibb.co.com/Z1xxdGS9/ebay-shop-by-con-6.jpg", alt: "Brightening for dull skin" },
  { slug: "tan", label: "Tanning", img: "https://i.ibb.co.com/sdgD57m9/ebay-shop-by-con-4.jpg", alt: "Anti-tan skincare" },
  { slug: "oily", label: "Oily Skin", img: "https://i.ibb.co.com/Z1xxdGS9/ebay-shop-by-con-6.jpg", alt: "Oil control skincare" },
  { slug: "dry", label: "Dry Skin", img: "https://i.ibb.co.com/m5QdTrdt/ebay-shop-by-con-5.jpg", alt: "Hydrating for dry skin" },
  { slug: "aging", label: "Aging", img: "https://i.ibb.co.com/TMrHjzSY/ebay-shop-by-con-1.jpg", alt: "Anti-aging skincare" },
  { slug: "spot", label: "Spot", img: "https://i.ibb.co.com/rfcCTtc8/ebay-shop-by-con-2.jpg", alt: "Spot treatment skincare" },
];

const structuredData = {
  "@context": "https://schema.org",
  "@type": "CollectionPage",
  name: "Shop by Concern",
  description:
    "Browse skincare and haircare products by concern including acne, dull skin, tanning, oily skin, dry skin, aging, and spots.",
  hasPart: concerns.map((c) => ({
    "@type": "CollectionPage",
    name: c.label,
    url: `https://earthbeautyandyou.com/product-category/${c.slug}`,
  })),
};

const ShopByConcern = () => {
  const [isDragging, setIsDragging] = useState(false);

  return (
    <section className="shopByConcern" aria-label="Shop by Skin & Hair Concerns">git 
      <script type="application/ld+json">{JSON.stringify(structuredData)}</script>

      {/* Section Header */}
      <div className="text-center mb-8 px-4">
        <span className="inline-block text-xs font-semibold tracking-[0.2em] uppercase text-[#729B7F] mb-3">
          Targeted Solutions
        </span>
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3">
          Shop by Concern
        </h2>
        <div className="w-14 h-0.5 bg-gradient-to-r from-[#729B7F] to-[#abcacb] mx-auto" />
      </div>

      <Swiper
        slidesPerView={2.5}
        spaceBetween={16}
        breakpoints={{
          480: { slidesPerView: 3, spaceBetween: 20 },
          768: { slidesPerView: 4, spaceBetween: 24 },
          1024: { slidesPerView: 5, spaceBetween: 28 },
          1400: { slidesPerView: 7, spaceBetween: 32 },
        }}
        grabCursor={!isDragging}
        onMouseDown={() => setIsDragging(true)}
        onMouseUp={() => setIsDragging(false)}
        className="shopConcern"
      >
        {concerns.map((concern) => (
          <SwiperSlide key={concern.slug}>
            <Link
              to={`/product-category/${concern.slug}`}
              title={`Shop ${concern.label} products`}
              className="concern-card flex flex-col items-center group"
            >
              <div className="relative rounded-full overflow-hidden ring-2 ring-transparent group-hover:ring-[#729B7F] transition-all duration-300 shadow-md">
                <img
                  className="w-[130px] h-[130px] lg:w-[155px] lg:h-[155px] rounded-full object-cover"
                  width={155}
                  height={155}
                  src={concern.img}
                  alt={concern.alt}
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-[#729B7F]/0 group-hover:bg-[#729B7F]/10 rounded-full transition-all duration-300" />
              </div>
              <p className="text-center mt-4 text-sm md:text-base font-semibold text-gray-800 group-hover:text-[#729B7F] transition-colors duration-200">
                {concern.label}
              </p>
            </Link>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};

export default ShopByConcern;





// import React, { useState } from "react";
// import { Swiper, SwiperSlide } from "swiper/react";
// import { Link } from "react-router-dom";

// import acne from "../../Images/acne.webp";
// import haircare from "../../Images/hair care.webp";
// import dullSkin from "../../Images/Dull Skin.webp";
// import tan from "../../Images/Tanning (1).webp";
// import oily from "../../Images/Oily skin.webp";
// import dry from "../../Images/Dry skin.webp";
// import aging from "../../Images/aging.webp";
// import spot from "../../Images/spot.jpg";

// import "./ShopByConcern.css";

// // ✅ Categories data (easier to manage)
// const concerns = [
//   { slug: "acne", label: "Acne", img: acne, alt: "Acne skincare products" },
//   { slug: "haircare", label: "Haircare", img: haircare, alt: "Hair care solutions" },
//   { slug: "dullskin", label: "Dull Skin", img: dullSkin, alt: "Brightening solutions for dull skin" },
//   { slug: "tan", label: "Tanning", img: tan, alt: "Anti-tan skincare" },
//   { slug: "oily", label: "Oily Skin", img: oily, alt: "Oil control skincare products" },
//   { slug: "dry", label: "Dry Skin", img: dry, alt: "Hydrating solutions for dry skin" },
//   { slug: "aging", label: "Aging", img: aging, alt: "Anti-aging skincare products" },
//   { slug: "spot", label: "Spot", img: spot, alt: "Spot treatment skincare" }
// ];

// const ShopByConcern = () => {
//   const [isDragging, setIsDragging] = useState(false);

//   const onMouseDown = () => setIsDragging(true);
//   const onMouseUp = () => setIsDragging(false);

//   // ✅ Structured Data for SEO
//   const structuredData = {
//     "@context": "https://schema.org",
//     "@type": "CollectionPage",
//     "name": "Shop by Concern",
//     "description": "Browse skincare and haircare products by concern including acne, dull skin, tanning, oily skin, dry skin, aging, and spots.",
//     "hasPart": concerns.map((concern) => ({
//       "@type": "CollectionPage",
//       "name": concern.label,
//       "url": `https://yourwebsite.com/product-category/${concern.slug}`
//     }))
//   };

//   return (
//     <section className="shopByConcern" aria-label="Shop by Skin & Hair Concerns">
//       {/* ✅ Structured Data for Rich Snippets */}
//       <script type="application/ld+json">
//         {JSON.stringify(structuredData)}
//       </script>

//       <Swiper
//         slidesPerView={2}
//         spaceBetween={10}
//         breakpoints={{
//           768: { slidesPerView: 3, spaceBetween: 20 },
//           1024: { slidesPerView: 4, spaceBetween: 25 },
//           1400: { slidesPerView: 6, spaceBetween: 30 }
//         }}
//         pagination={{ clickable: true }}
//         grabCursor={!isDragging}
//         onMouseDown={onMouseDown}
//         onMouseUp={onMouseUp}
//         className="shopConcern"
//       >
//         {concerns.map((concern, index) => (
//           <SwiperSlide key={concern.slug}>
//             <Link to={`/product-category/${concern.slug}`} title={`Shop ${concern.label} products`}>
//               <img
//                 className="w-[160px] h-[160px] lg:w-[180px] lg:h-[180px] rounded-full object-cover"
//                 width={180}
//                 height={180}
//                 src={concern.img}
//                 alt={concern.alt}
//                 loading="lazy"
//               />
//               <p className="text-center mt-6 text-2xl font-bold">{concern.label}</p>
//             </Link>
//           </SwiperSlide>
//         ))}
//       </Swiper>
//     </section>
//   );
// };

// export default ShopByConcern;
